module.exports = __webpack_public_path__ + "static/media/sign_in_background.9c7f98ee.png";